export const contingentConfigurationIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 13 12"><path d="M3 11.5v-2M3 3.5v-3M3 9.5a2 2 0 100-4 2 2 0 000 4zM10 .5v2M10 8.5v3M10 6.5a2 2 0 100-4 2 2 0 000 4z" stroke="#1A80BA" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'configuration',
};
